<template>
  <!-- 园区看板-专利保护状态-饼图 -->
	<div ref="myChart" :style="{margin: '0 auto',width: '100%', height: '100%'}"></div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		props: {
			echartDatas: {
				type: Object,
				default() {
					return {}
				}
			}
		},
		components: {
		},
		created() {
		},
		mounted() {
			this.drawChart()
		},
		methods: {
			drawChart() {
				// this.$refs.myChart.removeAttribute("_echarts_instance_")
				// document.getElementById('echartLine').removeAttribute("_echarts_instance_");
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(this.$refs.myChart, 'light')
        let typeColors = {
          技术方案质量: '#fac858',
          市场运用状况: '#91cc75',
          权利保护水平: '#5FACFC'
        }
        let echartDatas = this.echartDatas
        // 顺序 ['市场运用状况', '权利保护水平', '技术方案质量']
        let pami = (echartDatas.pami * 10).toFixed(2)
        let pali = (echartDatas.pali * 10).toFixed(2)
        let pati = (echartDatas.pati * 10).toFixed(2)
        let seriesDatas = [pami, pali, pati]
        // let seriesDatas = [echartsDatas.pami, echartsDatas.pali, echartsDatas.pati];
        // "pati": "6.28", // 技术方案质量
        // "pav": "68.32", // 综合质量
        // "pami": "5.90", // 市场运用状况
        // "pali": "6.03" // 权利保护水平
				// 指定图表的配置项和数据
				let option = {
					title: {
            text: '专利质量指数',
            x: 'center',
            textStyle: {
              fontSize: 18,
              fontWeight: 'normal',
              color: '#FFFFFF'
            },
            subtext: '综合指数: ' + echartDatas.pav,
            // subtext: '综合指数: 64.73',
            subtextStyle: {
              fontSize: 14,
              fontWeight: 'normal',
              color: '#FFC000'
            },
            itemGap: 10
          },
          polar: {
            radius: [30, '80%'],
            center: ['50%', '60%']
          },
          angleAxis: {
            max: 80,
            startAngle: 90,
            axisLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            splitNumber: 10,
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                width: 0.4
              }
            }
          },
          radiusAxis: {
            type: 'category',
            data: ['市场运用状况', '权利保护水平', '技术方案质量'],
            axisLabel: {
              show: false,
              fontSize: 14,
              color: '#ffffff'
            }
          },
          series: {
            type: 'bar',
            data: seriesDatas,
            // data: [54.37, 68.52, 55.23],
            itemStyle: {
              color: function (param) {
                return typeColors[param.name] || '#5470c6'
              }
            },
            coordinateSystem: 'polar',
            label: {
              show: true,
              position: 'start',
              formatter: '{b}: {c}',
              fontSize: 12,
              color: '#ffffff'
            },
            barCategoryGap: '40%'
          }
				}
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option)
			}
		},
		watch: {
			echartDatas: {
				handler() { // val, oldVal
					// console.log('当数量变化时重新绘制图表')//但是这两个值打印出来却都是一样的
					this.drawChart()
				}
			}
		}
	}
</script>

<style>
</style>
